<div class="otp-page">
  <!-- Onboarding Loading State -->
  <div class="onboarding-loading" *ngIf="bypassingOtp">
    <div class="loading-card">
      <div class="onboarding-spinner-wrapper">
        <div class="onboarding-spinner"></div>
        <div class="onboarding-logo-mini">
          <img *ngIf="shared.domainType == 'physio'" alt="logo" src="assets/media/logos/plus_physio_Logo.png"
            class="kt-header__brand-logo-default" style="width: 64px" />

          <img *ngIf="shared.domainType == 'doctor'" alt="logo" src="assets/media/logos/PlusDoctorLogo.png"
            class="kt-header__brand-logo-default" style="width: 64px" />

          <img *ngIf="shared.domainType == 'radiology'" alt="logo" src="assets/media/logos/Plus-Radiology.png"
            class="kt-header__brand-logo-default" style="width: 64px" />
        </div>
      </div>


      <h2 class="loading-title">
        {{ isBasicPlan ? 'Configuring Your Account' : 'Preparing Payment' }}
      </h2>

      <p class="loading-subtitle">
        {{
        isBasicPlan
        ? "We're setting up your clinic for you. This will only take a few moments."
        : "We're connecting you to our secure payment gateway. Please wait."
        }}
        <br />
        <span class="warning-text">Do not refresh or close this page.</span>
      </p>



      <div class="progress-container">
        <div class="progress-bar-fill"></div>
      </div>

      <div class="loading-steps-indicator">
        <div class="step-dot active"></div>
        <div class="step-dot active"></div>
        <div class="step-dot active"></div>
        <div class="step-dot active" style="animation: pulse-dot 1.5s infinite"></div>
      </div>
    </div>
  </div>

  <div class="otp-container" *ngIf="!bypassingOtp">
    <div class="otp-inner">

      <p class="otp-message">
        <strong>Congratulations, Your Clinic Registration process completed successfully.</strong>
        Please verify your email address using OTP received in your inbox.
      </p>
      <div class="otp-card">
        <!-- Logo -->
        <div class="logo">
          <a *ngIf="shared.domainType == 'physio'">
            <img src="assets/media/logos/plus_physio_Logo.png" alt="+Physio" />
          </a>
          <a *ngIf="shared.domainType == 'doctor'">
            <img src="assets/media/logos/PlusDoctorLogo.png" alt="+Doctor" />
          </a>
          <a *ngIf="shared.domainType == 'radiology'">
            <img src="assets/media/logos/Plus-Radiology.png" alt="+Doctor" />
          </a>
        </div>

        <!-- Title -->
        <h2 class="otp-title">OTP Verification</h2>
        <p class="otp-subtitle">Enter the OTP sent to your email</p>

        <div class="otp-phone">{{email}}</div>

        <!-- OTP Input Boxes -->
        <form [formGroup]="emailForm" (ngSubmit)="clickme()" class="otp-form">
          <div class="otp-boxes">
            <input *ngFor="let box of otpControls; let i = index" type="text" maxlength="1" class="otp-input"
              [id]="'otp-' + i" (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)" autocomplete="off"
              (paste)="onPaste($event)" />
          </div>

          <div class="resend-section">
            <button type="button" class="resend-btn" [disabled]="isResendDisabled || loadingResend"
              (click)="ResendCode()">
              Resend OTP
            </button>
            <span *ngIf="isResendDisabled" class="timer-text">in {{ formatTime(resendTimer) }}</span>
          </div>

          <button (click)="clickme()" id="kt_login_signin_submit" [class.spinner]="loading"
            class="btn btn-primary btn-elevate kt-login__btn-primary ml-2 verify-btn"
            [disabled]="isSubmitDisabled || !emailForm.valid || loading">
            Verify
          </button>
        </form>
      </div>
    </div>
  </div>
  <!-- Footer -->
  <div class="emailFooter">
    <div class="footer">
      <div class="kt-footer kt-footer--extended kt-grid__item" id="kt_footer">
        <div class="kt-footer__bottom">
          <div class="kt-container">
            <div class="kt-footer__wrapper">
              <div class="kt-footer__logo" style="display: flex;">
                <a *ngIf="shared.domainType == 'physio'" href="javascript:;" routerLink="/Appointments">
                  <img alt="logo" src="assets/media/logos/plus_physio_Logo.png" class="kt-header__brand-logo-default"
                    style="width: 64px;" />
                </a>
                <a *ngIf="shared.domainType == 'doctor'" href="javascript:;" routerLink="/Appointments">
                  <img alt="logo" src="assets/media/logos/PlusDoctorLogo.png" class="kt-header__brand-logo-default"
                    style="width: 64px;" />
                </a>
                <a *ngIf="shared.domainType == 'radiology'" href="javascript:;" routerLink="/Appointments">
                  <img alt="logo" src="assets/media/logos/Plus-Radiology.png" class="kt-header__brand-logo-default"
                    style="width: 64px;" />
                </a>
                <div [ngStyle]="{'margin-top': '27px'}">
                  <span class="ft_position">{{currentApplicationVersion}}</span>
                </div>
              </div>
              <div class="kt-footer__menu">
                <div class="kt-footer__copyright ml-3">
                  Copyright © {{ today | date : "yyyy" }} iFour Technolab Pvt. Ltd. All rights reserved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #paymentfailedDialog>
  <div class="dialog-status-card failed">
    <div class="status-icon-wrapper">
      <mat-icon class="status-icon">cancel</mat-icon>
    </div>
    <h3 class="status-title">Payment Unsuccessful</h3>
    <div class="status-content">
      <p>It looks like your transaction didn’t go through.</p>
      <p>Please contact us for assistance with completing your payment.</p>

      <div class="contact-info">
        <div class="contact-item">
          <mat-icon>email</mat-icon>
          <a href="mailto:support@plusphysio.com">{{support}}</a>
        </div>
        <div class="contact-item">
          <mat-icon>phone</mat-icon>
          <a href="tel:7863093997">7863093997</a>
        </div>
      </div>
    </div>
    <div class="dialog-actions">
      <button type="button" [mat-dialog-close]="true" class="btn btn-secondary w-100">
        OK
      </button>
    </div>
  </div>
</ng-template>

<ng-template #addonFailedDialog>
  <div class="dialog-status-card warning">
    <div class="status-icon-wrapper">
      <mat-icon class="status-icon">info</mat-icon>
    </div>
    <h3 class="status-title">Add-on Payment Skipped</h3>
    <div class="status-content">
      <p>The add-on payment was not completed.</p>
      <p><strong>Don't worry!</strong> Your base plan is already active. You can purchase these add-ons anytime from your dashboard.</p>
    </div>
    <div class="dialog-actions">
      <button type="button" [mat-dialog-close]="true" class="btn btn-primary w-100">
        Got it, Thanks
      </button>
    </div>
  </div>
</ng-template>